module.exports = __webpack_public_path__ + "img/home-clothing5.aa417341.png";